// Prototype. Do not instantiate, but extend this class in order to create custom column cells.
// https://www.ag-grid.com/javascript-data-grid/component-cell-renderer/
// Don't forget to use OnPush change detection strategy and
// list localStore as a component provider
// https://codecraft.tv/courses/angular/dependency-injection-and-providers/ngmodule-providers-vs-component-providers-vs-component-viewproviders/
// in child classes

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgCellLocalStoreService, AgCellState } from './ag-cell-local-store.service';

@Component({
  template: '',
})
export abstract class AgCellRendererComponent implements ICellRendererAngularComp {

  protected constructor(protected localStore: AgCellLocalStoreService<AgCellState>) {
  }

  // Mandatory - Params for rendering
  // Gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.localStore.updateCellValue(this.getValueToDisplay(params));
    this.localStore.updateParams(params);
  }

  // Mandatory - Return true if you have managed the cell refresh yourself in this method, otherwise return false.
  // If you return false, the grid will remove the component from the DOM and create a new component in its place
  // with the new values.
  // Gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.localStore.updateCellValue(this.getValueToDisplay(params));
    // update params
    this.localStore.updateParams(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ?
        params.valueFormatted : // Formatted value to be rendered (if a formatter function has been provided in the column options)
        params.value; // Value to be rendered
  }

}
